import { getInputModality } from '#pplx/frontend/aether/getInputModality.js';
import { useEffect, useState } from 'react';
/**
 * Returns whether the Composer's text-field focus ring should be visible.
 *
 * Each editor focus session samples page modality. While focused, Tab or Escape
 * enables the ring, and pointerdown or blur clears it. Typing and caret keys leave
 * its visibility unchanged.
 */
export function useComposerFocusRing({ isActive }) {
    const [isFocusRingVisible, setFocusRingVisible] = useState(false);
    // WHY useEffect: Lexical owns editor focus, so observe document input during that
    // focus session without adding handlers to consumer editors.
    useEffect(() => {
        if (!isActive) {
            setFocusRingVisible(false);
            return;
        }
        setFocusRingVisible(getInputModality() === 'keyboard');
        const handleKeyDown = (event) => {
            // Caret keys can change page modality without making a text field's ring visible.
            if (event.key === 'Tab' || event.key === 'Escape') {
                setFocusRingVisible(true);
            }
        };
        const handlePointerDown = () => setFocusRingVisible(false);
        document.addEventListener('keydown', handleKeyDown, true);
        document.addEventListener('pointerdown', handlePointerDown, true);
        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
            document.removeEventListener('pointerdown', handlePointerDown, true);
        };
    }, [isActive]);
    return isActive && isFocusRingVisible;
}
//# sourceMappingURL=useComposerFocusRing.js.map